"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPhoneList = getPhoneList;
exports.initBase = initBase;

var _ = require("../");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var countryTimezone;
var phoneList = [];

function initBase(config) {
  countryTimezone = config;
  return new Promise(function (resolve, reject) {
    return resolve();
  });
}

function getPhoneList() {
  if (!phoneList.length) {
    var list = countryTimezone ? Object.entries(countryTimezone).map(function (item) {
      return _defineProperty({}, item[0], '+' + item[1].country_calling_code);
    }) : [];
    return list;
  }

  return phoneList;
}